import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchIconWithIndicator',
  props: {
    darkMode: { type: Boolean },
    colorShade: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
  darkMode: boolean
  colorShade: 'text-200'
  size: number
}



// This follows `text-dark-text` and `text-light-text` in Orizuru
const iconColor = computed(() => {
  switch (props.colorShade) {
    case 'text-200':
      return props.darkMode ? 'white' : 'black'
    default:
      return props.darkMode ? 'white' : 'black'
  }
})
const iconOpacity = computed(() => {
  switch (props.colorShade) {
    case 'text-200':
      return props.darkMode ? '0.7' : '0.54'
    default:
      return 1
  }
})

// This is Orizuru selection color
const indicatorColor = computed(() => (props.darkMode ? '#FEC006' : '#9466E8'))

return { __sfc: true,props, iconColor, iconOpacity, indicatorColor }
}

})